;(() => {
  // Add / Update a key-value pair in the URL query parameters
  // https://gist.github.com/niyazpk/f8ac616f181f6042d1e0
  function updateUrlParameter(uri, key, value) {
    const hashIndex = uri.indexOf("#")
    const hash = hashIndex === -1 ? "" : uri.substr(hashIndex)
    const uriWithoutHash = hashIndex === -1 ? uri : uri.substr(0, hashIndex)

    const re = new RegExp(`([?&])${key}=.*?(&|$)`, "i")
    const separator = uriWithoutHash.indexOf("?") !== -1 ? "&" : "?"

    if (uriWithoutHash.match(re)) {
      return uriWithoutHash.replace(re, `$1${key}=${value}$2`) + hash
    }

    return `${uriWithoutHash + separator + key}=${value}${hash}`
  }

  function actualizeCurrencyHref(event) {
    const currencyVal = event.currentTarget.dataset.currency
    if (currencyVal) {
      window.location.href = updateUrlParameter(
        window.location.href,
        "currency",
        currencyVal,
      )
    }
  }

  $(() => {
    const $links = $(".dropdown-container_currency").find(".dropdown-i-link")

    $links.on("click", actualizeCurrencyHref)

    // mobile / other currencies, which implemented as "select"
    $(".dropdown-container_currency .dropdown-i-select").on(
      "change",
      function changeHandler() {
        const currencyVal = $(this).val()
        window.location.href = updateUrlParameter(
          window.location.href,
          "currency",
          currencyVal,
        )
      },
    )
  })
})()
